import { StringParam, withDefault } from 'use-query-params';
import {
  CustomStringParam,
  FilterType,
  SchemaFilterType,
  SortDir,
} from '@ui/src';
import { CardStatus } from '../types';

export const cardsListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'customer',
    label: 'Customer',
    sortable: true,
  },
  {
    name: 'account',
    label: 'Customer account',
    sortable: true,
  },
  {
    name: 'cardType',
    label: 'Card type',
    sortable: true,
  },
  {
    name: 'virtual',
    label: 'Type',
  },
  {
    name: 'pan',
    label: 'Card pan',
    sortable: true,
  },
  {
    name: 'status',
    label: 'Card status',
    filterModalPlacement: 'right',
    sortable: true,
  },
  {
    name: 'balance',
    label: 'Balance',
    filterModalPlacement: 'right',
    sortable: true,
  },
];

export const cardsListColumnsLabels = {
  customer: 'Customer',
  account: 'Customer account',
  cardType: 'Card type',
  pan: 'Card pan',
  status: 'Card status',
  balance: 'Balance',
};

export const cardsListDefaultSorter = {
  sortProp: cardsListColumns[1].name,
  sortDir: SortDir.ASC,
};

export const cardsListSchema = {
  customer: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  account: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  cardType: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  pan: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  status: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  balance: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  sortProp: {
    value: withDefault(StringParam, cardsListDefaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, cardsListDefaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const cardsListFiltersSchema = [
  {
    name: 'status',
    type: FilterType.CHECKBOX,
    fields: [
      {
        name: 'status',
        title: CardStatus.ACTIVE,
        value: CardStatus.ACTIVE,
      },
      {
        name: 'status',
        title: CardStatus.NEW,
        value: CardStatus.NEW,
      },
      {
        name: 'status',
        title: CardStatus.APPROVED,
        value: CardStatus.APPROVED,
      },
      {
        name: 'status',
        title: CardStatus.CANCELED,
        value: CardStatus.CANCELED,
      },
      {
        name: 'status',
        title: CardStatus.IN_PROCESS,
        value: CardStatus.IN_PROCESS,
      },
      {
        name: 'status',
        title: CardStatus.ORDERED,
        value: CardStatus.ORDERED,
      },
      {
        name: 'status',
        title: CardStatus.FROZEN,
        value: CardStatus.FROZEN,
      },
      {
        name: 'status',
        title: CardStatus.VOID,
        value: CardStatus.VOID,
      },
    ],
  },
  {
    name: 'customer',
    type: FilterType.TEXT,
    placeholder: 'Search by customer...',
  },
  {
    name: 'account',
    type: FilterType.TEXT,
    placeholder: 'Search by account...',
  },
  {
    name: 'cardType',
    type: FilterType.CHECKBOX,
    fields: [
      {
        name: 'cardType',
        title: 'Debit',
        value: 'debit',
      },
      {
        name: 'cardType',
        title: 'Credit',
        value: 'credit',
      },
    ],
  },
  {
    name: 'pan',
    type: FilterType.TEXT,
    placeholder: 'Enter pan...',
  },
  {
    name: 'balance',
    type: FilterType.TEXT,
    placeholder: 'Enter balance sum...',
  },
];
